/* =====================================================================
   Sunnafrucht — Lovable Product Template interactions (vanilla JS)
   No framework. Re-runs safely in the Shopify theme editor.
   ===================================================================== */
(function () {
  "use strict";

  /* Waehrung des Besuchers (Shopify Markets) statt fest EUR: Die Cent-Betraege aus dem
     Template sind bereits in dieser Waehrung (z. B. CHF fuer die Schweiz). CHF im
     Schweizer Format ("CHF 16.00"), so wie im Warenkorb. EUR bleibt "16,00 €". */
  var shopCur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
  var eur;
  try {
    eur = new Intl.NumberFormat(shopCur === "CHF" ? "de-CH" : "de-DE", { style: "currency", currency: shopCur });
  } catch (e) {
    eur = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });
  }
  function fmt(cents) { return eur.format(cents / 100); }
  /* ganze Betraege ohne ",00" (fuer Texte wie "Versandfrei ab 150 €") */
  function fmtShort(cents) { return cents % 100 === 0 ? fmt(cents).replace(/[.,]00(?!\d)/, "") : fmt(cents); }

  /* ---------- Open the Local cart sidebar after an AJAX add ----------
     Local's drawer is <sidebar-drawer id="site-cart-sidebar">. Its open state
     is class "sidebar--opened" + style display:grid. We first re-render the
     drawer contents (so the just-added item shows), then open it. No /cart redirect.
     Optional override: data-cart-open="<selector>" on .lvp (clicks that trigger instead).
  */
  function showLocalSidebar(sb) {
    if (!sb) return false;
    sb.classList.add("sidebar--opened");
    sb.style.display = "grid";
    sb.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("js-drawer-open", "drawer-open");
    document.body.classList.add("js-drawer-open", "drawer-open");
    bindLocalSidebarClose();
    try { sb.focus(); } catch (e) {}
    return true;
  }

  function closeLocalSidebar() {
    var sb = document.getElementById("site-cart-sidebar");
    if (!sb) return;
    sb.classList.remove("sidebar--opened");
    sb.style.display = "";               // let theme CSS hide it again
    sb.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("js-drawer-open", "drawer-open");
    document.body.classList.remove("js-drawer-open", "drawer-open");
  }

  var LOCAL_CLOSE_BOUND = false;
  function bindLocalSidebarClose() {
    if (LOCAL_CLOSE_BOUND) return;
    LOCAL_CLOSE_BOUND = true;

    // click outside the drawer closes it
    document.addEventListener("click", function (e) {
      var sb = document.getElementById("site-cart-sidebar");
      if (!sb || !sb.classList.contains("sidebar--opened")) return;
      if (sb.contains(e.target)) return; // clicks inside the drawer are fine
      // ignore the buttons that open/refresh the drawer
      if (e.target.closest && e.target.closest(
        "[data-syn-add],[data-add],[aria-controls='site-cart-sidebar']," +
        "[data-js-site-cart-trigger],[data-js-mini-cart-trigger]"
      )) return;
      closeLocalSidebar();
    });

    // the drawer's own close button
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest("#site-cart-sidebar [data-js-close]")) {
        closeLocalSidebar();
      }
    });

    // Escape closes it
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) closeLocalSidebar();
    });
  }

  function refreshLocalCart() {
    // Re-fetch the current page (the sidebar is in the layout on every page) and
    // swap the live cart nodes so the drawer shows the updated cart.
    return fetch(window.location.pathname + (window.location.search || ""), {
      headers: { "X-Requested-With": "XMLHttpRequest" },
      cache: "no-store"
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        ["#AjaxCartForm", "#AjaxCartSubtotal"].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var cur = document.querySelector(sel);
          if (fresh && cur) { cur.replaceWith(fresh); }
        });
        // header count + sidebar item count
        var fc = doc.querySelector("[data-header-cart-count]");
        var cc = document.querySelector("[data-header-cart-count]");
        if (fc && cc) cc.textContent = fc.textContent;
        var fCount = doc.querySelector("[data-cart-count]");
        var cCount = document.querySelector("[data-cart-count]");
        if (fCount && cCount) cCount.textContent = fCount.textContent;
        var fSb = doc.getElementById("site-cart-sidebar");
        var cSb = document.getElementById("site-cart-sidebar");
        if (fSb && cSb && fSb.getAttribute("data-cart-items")) {
          cSb.setAttribute("data-cart-items", fSb.getAttribute("data-cart-items"));
        }
      });
  }

  function openCartDrawer(root) {
    // explicit override wins
    var sel = root && root.getAttribute && root.getAttribute("data-cart-open");
    if (sel) { var t = document.querySelector(sel); if (t) { t.click(); return; } }

    var sidebar = document.getElementById("site-cart-sidebar");
    if (sidebar) {
      refreshLocalCart()
        .then(function () { showLocalSidebar(sidebar); })
        .catch(function () { showLocalSidebar(sidebar); });
      return;
    }

    // fallbacks if the sidebar markup ever changes
    try {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true, detail: { openMiniCart: true }
      }));
    } catch (e) {}
    var trigger = document.querySelector(
      "[aria-controls='site-cart-sidebar'],[data-js-site-cart-trigger],[data-js-mini-cart-trigger],.js-drawer-open-cart,#cart-icon-bubble"
    );
    if (trigger) trigger.click();
    // intentionally NO window.location redirect
  }

  /* Add an array of {id, quantity, properties} line items, then open the sidebar */
  function addToCartAndOpen(items, root, btn) {
    if (!items || !items.length) return;
    if (btn) btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) { throw new Error("add failed"); } return r.json(); })
      .then(function () { openCartDrawer(root); })
      .catch(function () {})
      .then(function () { if (btn) btn.disabled = false; });
  }

  function init(root) {
    if (!root || root.dataset.lvpInit === "1") return;
    root.dataset.lvpInit = "1";

    var baseCents = parseInt(root.dataset.baseCents, 10) || 3600;     // unit price
    var compareCents = parseInt(root.dataset.compareCents, 10) || 4400; // struck unit price

    /* ---------- Nav scroller arrows ---------- */
    var scroller = root.querySelector("[data-nav-scroller]");
    if (scroller) {
      var prev = root.querySelector("[data-nav-prev]");
      var next = root.querySelector("[data-nav-next]");
      var step = function (dir) { scroller.scrollBy({ left: dir * Math.max(240, scroller.clientWidth * 0.6), behavior: "smooth" }); };
      if (prev) prev.addEventListener("click", function () { step(-1); });
      if (next) next.addEventListener("click", function () { step(1); });
    }

    /* ---------- Gallery ---------- */
    var rail = root.querySelector("[data-gallery-rail]");
    if (rail) {
      var slides = rail.children.length;
      var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-thumb]"));
      var current = 0;
      var go = function (i) {
        current = Math.max(0, Math.min(slides - 1, i));
        rail.style.transform = "translateX(" + (-current * 100) + "%)";
        thumbs.forEach(function (t, ti) { t.classList.toggle("is-active", ti === current); });
        Array.prototype.forEach.call(rail.querySelectorAll(".lvp-gallery__slide"), function (slide, n) {
          var video = slide.querySelector("video");
          if (!video) return;
          if (n === current) {
            var play = video.play();
            if (play && play.catch) play.catch(function () {});
          } else {
            video.pause();
          }
        });
      };
      Array.prototype.forEach.call(rail.querySelectorAll("[data-gallery-play]"), function (btn) {
        var slide = btn.closest(".lvp-gallery__slide");
        var video = slide && slide.querySelector("video");
        if (!video) return;
        var mark = function (playing) { slide.classList.toggle("is-playing", playing); };
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        });
        video.addEventListener("play", function () { mark(true); });
        video.addEventListener("pause", function () { mark(false); });
        video.addEventListener("ended", function () { mark(false); });
      });
      thumbs.forEach(function (t) { t.addEventListener("click", function () { go(parseInt(t.dataset.thumb, 10)); }); });
      var gp = root.querySelector("[data-gallery-prev]");
      var gn = root.querySelector("[data-gallery-next]");
      if (gp) gp.addEventListener("click", function () { go(current - 1); });
      if (gn) gn.addEventListener("click", function () { go(current + 1); });
    }

    /* ---------- Sensory scales (render 5 bars) ---------- */
    root.querySelectorAll("[data-scale]").forEach(function (sc) {
      var val = parseInt(sc.dataset.scale, 10) || 0;
      var bars = sc.querySelector(".lvp-scale__bars");
      if (!bars) return;
      for (var i = 0; i < 5; i++) {
        var s = document.createElement("span");
        if (i < val) s.className = "on";
        bars.appendChild(s);
      }
    });

    /* ---------- Voice note ---------- */
    var voice = root.querySelector("[data-voice]");
    if (voice) {
      var audio = voice.querySelector("[data-voice-audio]");
      var duration = parseInt(voice.dataset.duration, 10) || 51;
      var wave = voice.querySelector("[data-voice-wave]");
      var timeEl = voice.querySelector("[data-voice-time]");
      var playBtn = voice.querySelector("[data-voice-play]");
      var icon = voice.querySelector("[data-voice-icon]");
      var bars = 32, barEls = [];
      for (var b = 0; b < bars; b++) {
        var sp = document.createElement("span");
        sp.style.height = (25 + ((b * 53) % 75)) + "%";
        wave.appendChild(sp); barEls.push(sp);
      }
      var progress = 0, timer = null, playing = false;
      var tstr = function (s) { return Math.floor(s / 60) + ":" + String(Math.floor(s % 60)).padStart(2, "0"); };
      var paint = function () {
        var ratio = duration ? (progress / duration) : 0;
        barEls.forEach(function (el, i) { el.classList.toggle("on", (i + 1) / bars <= ratio); });
        timeEl.textContent = (playing || progress > 0) ? tstr(progress) : tstr(duration);
      };
      var playSvg = '<path d="M8 5v14l11-7z"/>';
      var pauseSvg = '<path d="M6 4h4v16H6zM14 4h4v16h-4z"/>';
      if (audio) {
        /* Real audio playback */
        audio.addEventListener("loadedmetadata", function () { if (audio.duration && isFinite(audio.duration)) { duration = audio.duration; paint(); } });
        audio.addEventListener("timeupdate", function () { progress = audio.currentTime; paint(); });
        audio.addEventListener("ended", function () { playing = false; progress = 0; if (icon) icon.innerHTML = playSvg; paint(); });
        playBtn.addEventListener("click", function () {
          if (audio.paused) { audio.play(); playing = true; if (icon) icon.innerHTML = pauseSvg; }
          else { audio.pause(); playing = false; if (icon) icon.innerHTML = playSvg; }
        });
      } else {
        /* Demo animation when no audio file is set */
        var stop = function () { if (timer) clearInterval(timer); timer = null; playing = false; if (icon) icon.innerHTML = playSvg; };
        playBtn.addEventListener("click", function () {
          if (playing) { stop(); return; }
          playing = true; if (icon) icon.innerHTML = pauseSvg;
          timer = setInterval(function () {
            progress += 0.25;
            if (progress >= duration) { progress = duration; stop(); }
            paint();
          }, 250);
        });
      }
      voice.querySelectorAll("[data-react]").forEach(function (r) {
        r.addEventListener("click", function () {
          var on = r.classList.toggle("is-on");
          var num = r.querySelector(".num");
          if (num) num.textContent = parseInt(num.textContent, 10) + (on ? 1 : -1);
        });
      });
      paint();
    }

    /* ---------- Pricing state (set picker + plan + qty) ---------- */
    var tiers = Array.prototype.slice.call(root.querySelectorAll("[data-tier]"));
    var planOpts = Array.prototype.slice.call(root.querySelectorAll("[data-plan-opt]"));
    var qtyDisplay = root.querySelector("[data-qty-display]");
    var qtyInput = root.querySelector("[data-qty-input]");
    var priceNow = root.querySelector("[data-price-now]");
    var priceWas = root.querySelector("[data-price-was]");
    var priceSave = root.querySelector("[data-price-save]");
    var unitCount = root.querySelector("[data-set-unitcount]");
    var discountBadge = root.querySelector("[data-discount-badge]");

    /* Neutral default for products WITHOUT set-picker tiers (custom.product_quantity
       empty -> no [data-tier] nodes -> the tier adoption below never runs).
       Must stay qty 1 / save 0, otherwise the page shows a quantity and a discount
       that the cart will not honour. */
    var state = { qty: 1, save: 0, plan: "once" };

    // adopt the server-rendered active tier (placement / metafield default)
    var initActive = tiers.filter(function (t) { return t.classList.contains("is-active"); })[0] || tiers[0];
    if (initActive) {
      var iq = parseInt(initActive.dataset.qty, 10);
      var isv = parseInt(initActive.dataset.save, 10);
      if (!isNaN(iq)) state.qty = iq;
      if (!isNaN(isv)) state.save = isv;
    }

    function tierUnit(saveP) { return Math.round(baseCents * (1 - saveP / 100)); }

    function paintTiers() {
      tiers.forEach(function (t) {
        var q = parseInt(t.dataset.qty, 10);
        var sv = parseInt(t.dataset.save, 10);
        var unit = tierUnit(sv);
        var total = unit * q;
        /* Struck total must use the same reference price as the price bar below
           (paintPrice -> compareCents * qty). Rendered ONLY when it is actually
           higher than what is being paid: on products whose compare-at price
           equals the selling price the 0 % row would otherwise strike a price
           through an identical one. */
        var was = compareCents * q;
        var set = function (sel, txt) { var e = t.querySelector(sel); if (e) e.textContent = txt; };
        set("[data-tier-unit]", fmt(unit));
        /* Stueckpreis reference stays baseCents on purpose: it shows what one unit
           costs WITHOUT the bundle discount, which is the saving this row promises. */
        set("[data-tier-unitwas]", sv > 0 ? fmt(baseCents) : "");
        set("[data-tier-total]", fmt(total));
        set("[data-tier-was]", was > total ? fmt(was) : "");
        t.classList.toggle("is-active", q === state.qty);
      });
    }

    function paintPrice() {
      var unit = tierUnit(state.save);
      var baseTotal = unit * state.qty;
      var wasTotal = compareCents * state.qty;
      var finalTotal = state.plan === "sub" ? Math.round(baseTotal * 0.9) : baseTotal;
      var saved = wasTotal - finalTotal;
      if (priceNow) priceNow.textContent = fmt(finalTotal);
      /* Struck price and "Du sparst" are suppressed when there is nothing to save.
         display:none matters on the saving pill: it has its own background and
         padding, so clearing only the text would leave an empty coloured capsule. */
      if (priceWas) {
        priceWas.textContent = saved > 0 ? fmt(wasTotal) : "";
        priceWas.style.display = saved > 0 ? "" : "none";
      }
      if (priceSave) {
        priceSave.textContent = saved > 0 ? "Du sparst " + fmt(saved) : "";
        priceSave.style.display = saved > 0 ? "" : "none";
      }
      /* Sale badge on the gallery image tracks the CURRENT selection, so picking a
         bundle tier shows that tier's real percentage. Hidden whenever there is no
         saving at all (e.g. compare-at price equal to the selling price on a 0 % tier). */
      if (discountBadge) {
        if (saved > 0 && wasTotal > 0) {
          discountBadge.textContent = "−" + Math.round((saved / wasTotal) * 100) + " %";
          discountBadge.style.display = "";
        } else {
          discountBadge.style.display = "none";
        }
      }
      if (unitCount) {
                var unitLabel = unitCount.getAttribute("data-unit") || "";
        unitCount.textContent = unitLabel ? state.qty + " × " + unitLabel : String(state.qty);
      }
      if (qtyDisplay) qtyDisplay.textContent = state.qty;
      if (qtyInput) qtyInput.value = state.qty;
    }

    // derive save% for an arbitrary qty (highest tier whose qty <= current)
    function saveForQty(q) {
      var best = 0;
      tiers.forEach(function (t) {
        var tq = parseInt(t.dataset.qty, 10);
        if (tq <= q) best = parseInt(t.dataset.save, 10);
      });
      return best;
    }

    tiers.forEach(function (t) {
      t.addEventListener("click", function () {
        state.qty = parseInt(t.dataset.qty, 10);
        state.save = parseInt(t.dataset.save, 10);
        paintTiers(); paintPrice();
      });
    });

    planOpts.forEach(function (o) {
      o.addEventListener("click", function () {
        state.plan = o.dataset.planOpt;
        planOpts.forEach(function (x) { x.classList.toggle("is-active", x === o); });
        paintPrice();
      });
    });

    var minus = root.querySelector("[data-qty-minus]");
    var plus = root.querySelector("[data-qty-plus]");
    if (minus) minus.addEventListener("click", function () { state.qty = Math.max(1, state.qty - 1); state.save = saveForQty(state.qty); paintTiers(); paintPrice(); });
    if (plus) plus.addEventListener("click", function () { state.qty += 1; state.save = saveForQty(state.qty); paintTiers(); paintPrice(); });

    paintTiers(); paintPrice();

    /* ---------- Versandfrei-Hinweis an Land und Waehrung anpassen ----------
       Im Template steht fest "Versandfrei ab 60 €" (Grenze fuer Deutschland).
       Ausserhalb Deutschlands gilt die Grenze aus dem Warenkorb-Hinweis
       (<shipping-notice data-free-shipping>, Shop-Waehrung in Cent), umgerechnet
       mit Shopify.currency.rate wie im Warenkorb. */
    var fixShipNote = function () {
      var shipNote = root.querySelector(".lvp-price__meta .muted");
      var shipNotice = document.querySelector("shipping-notice[data-free-shipping]");
      if (!shipNote || !shipNotice || !window.Shopify || !window.Shopify.country || window.Shopify.country === "DE") return;
      var shipRate = (window.Shopify.currency && Number(window.Shopify.currency.rate)) || 1;
      var shipCents = Math.round((Number(shipNotice.getAttribute("data-free-shipping")) || 0) * shipRate);
      if (shipCents > 0) {
        shipNote.textContent = shipNote.textContent.replace(/Versandfrei ab\s*[\d.,]+\s*(€|EUR|CHF)?/, "Versandfrei ab " + fmtShort(shipCents));
      }
    };
    fixShipNote();
    window.addEventListener("load", fixShipNote);

    /* ---------- Main add-to-cart: AJAX add + open drawer (no /cart redirect) ---------- */
    var buyForm = root.querySelector("#lvp-form");
    if (!buyForm) {
      var addEl = root.querySelector("[data-add]");
      if (addEl && addEl.closest) buyForm = addEl.closest("form");
    }
    if (buyForm) {
      buyForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var idInput = buyForm.querySelector("[name='id']");
        var id = idInput ? parseInt(idInput.value, 10) : 0;
        if (!id) return;
        var qtyEl = buyForm.querySelector("[data-qty-input]") || buyForm.querySelector("[name='quantity']");
        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;

        // collect any hidden line-item properties on the form
        var props = {}, hasProps = false;
        buyForm.querySelectorAll("input[name^='properties[']").forEach(function (inp) {
          var m = inp.name.match(/properties\[(.+)\]/);
          if (m) { props[m[1]] = inp.value; hasProps = true; }
        });

        var line = { id: id, quantity: qty };
        if (hasProps) line.properties = props;
        addToCartAndOpen([line], root, buyForm.querySelector("[data-add]"));
      });
    }

    /* ---------- Lab values ---------- */
    var labTabs = Array.prototype.slice.call(root.querySelectorAll("[data-lab]"));
    if (labTabs.length) {
      var lp = {
        label: root.querySelector("[data-lab-label]"),
        val: root.querySelector("[data-lab-val]"),
        progress: root.querySelector("[data-lab-progress]"),
        bench: root.querySelector("[data-lab-benchtick]"),
        min: root.querySelector("[data-lab-min]"),
        max: root.querySelector("[data-lab-max]"),
        benchLabel: root.querySelector("[data-lab-benchlabel]"),
        info: root.querySelector("[data-lab-info]")
      };
      var setLab = function (tab) {
        labTabs.forEach(function (t) { t.classList.toggle("is-on", t === tab); });
        var d = tab.dataset;
        var value = parseFloat(d.value), min = parseFloat(d.min), max = parseFloat(d.max), bench = parseFloat(d.bench);
        var pct = ((value - min) / (max - min)) * 100;
        var benchPct = ((bench - min) / (max - min)) * 100;
        lp.label.textContent = tab.querySelector(".k").textContent;
        lp.val.innerHTML = value + '<small>' + d.unit + '</small>';
        lp.progress.style.width = pct + "%";
        lp.bench.style.left = benchPct + "%";
        lp.min.textContent = min + " " + d.unit;
        lp.max.textContent = max + " " + d.unit;
        lp.benchLabel.textContent = "Marktdurchschnitt " + bench + " " + d.unit;
        lp.info.textContent = d.info;
      };
      labTabs.forEach(function (t) { t.addEventListener("click", function () { setLab(t); }); });
      setLab(labTabs[0]);
    }

    /* ---------- Glass comparison ---------- */
    var glass = root.querySelector("[data-glass]");
    if (glass) {
      var gTabs = Array.prototype.slice.call(glass.querySelectorAll("[data-glass-tab]"));
      var gUv = glass.querySelector("[data-glass-uv]");
      var gVis = glass.querySelector("[data-glass-vis]");
      var gIr = glass.querySelector("[data-glass-ir]");
      var gVerdict = glass.querySelector("[data-glass-verdict]");
      var gCurve = glass.querySelector("[data-glass-curve]");
      var gGlow = glass.querySelector("[data-glass-glow]");
      var gPros = glass.querySelector("[data-glass-pros]");
      var gCons = glass.querySelector("[data-glass-cons]");
      var fillList = function (ul, items, mark, color) {
        if (!ul) return;
        ul.innerHTML = "";
        items.forEach(function (txt) {
          if (!txt) return;
          var li = document.createElement("li");
          li.innerHTML = '<span style="flex:none;color:' + color + '">' + mark + '</span><span>' + txt + '</span>';
          ul.appendChild(li);
        });
      };
      var setGlass = function (tab) {
        gTabs.forEach(function (t) { t.classList.toggle("is-on", t === tab); });
        var d = tab.dataset;
        gUv.textContent = d.uv + "%";
        gVis.textContent = d.vis + "%";
        gIr.textContent = d.ir + "%";
        gVerdict.textContent = d.verdict;
        if (gCurve && d.curve) { gCurve.setAttribute("d", d.curve); }
        if (gGlow && d.curve) { gGlow.setAttribute("d", d.curve); }
        fillList(gPros, (d.pros || "").split("|"), "✓", "var(--lvp-gold)");
        fillList(gCons, (d.cons || "").split("|"), "–", "rgba(247,243,236,.5)");
      };
      gTabs.forEach(function (t) { t.addEventListener("click", function () { setGlass(t); }); });
      var gActive = glass.querySelector("[data-glass-tab].is-on") || gTabs[0];
      if (gActive) { setGlass(gActive); }
    }

    /* ---------- Synergy ---------- */
    var syn = root.querySelector("[data-syn]");
    if (syn) {
      var synItems = Array.prototype.slice.call(syn.querySelectorAll("[data-syn-item]"));
      var synTotal = syn.querySelector("[data-syn-total]");
      var paintSyn = function () {
        var total = 0;
        synItems.forEach(function (it) { if (it.classList.contains("is-on")) total += parseInt(it.dataset.price, 10); });
        if (synTotal) synTotal.textContent = fmt(total);
      };
      synItems.forEach(function (it) { it.addEventListener("click", function () { it.classList.toggle("is-on"); paintSyn(); }); });
      paintSyn();
      /* Add the checked upsell products to cart, then OPEN THE CART DRAWER
         (Local mini-cart, no redirect to /cart). */
      var synAdd = syn.querySelector("[data-syn-add]");
      if (synAdd) {
        synAdd.addEventListener("click", function () {
          var items = synItems
            .filter(function (it) { return it.classList.contains("is-on") && it.dataset.vid; })
            .map(function (it) { return { id: parseInt(it.dataset.vid, 10), quantity: 1 }; });
          addToCartAndOpen(items, root, synAdd);
        });
      }
    }

    /* ---------- Sticky CTA ---------- */
    var sticky = root.querySelector("[data-sticky]");
    var addBtn = root.querySelector("[data-add]");
    if (sticky && addBtn && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle("is-hidden", entries[0].isIntersecting);
      }, { threshold: 0.01 });
      io.observe(addBtn);
    }
  }

  function boot() { document.querySelectorAll(".lvp").forEach(init); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }

  // Shopify theme editor: re-init when section is re-rendered
  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll(".lvp").forEach(init);
  });
})();